const {Component} = require("react");
const PropTypes = require("prop-types");
const moment = require("moment");
const Pikaday = require("pikaday");
const env = require("services/env");
const hammer = require("helpers/hammer");
const {pluckKeysExcept} = require("helpers/object");
const $ = require("helpers/element");
const {methodNotImplemented} = require("helpers/errors");
const IMask = require("imask/dist/imask");
const DateClass = (global || window).Date;

class Date extends Component {

    static get propTypes() {
        return {
            format: PropTypes.string,
            min: PropTypes.string,
            max: PropTypes.string,
            value: PropTypes.string,
            defaultValue: PropTypes.string,
            onChange: PropTypes.func,
            handleChange: PropTypes.func,
            tapCloseSelector: PropTypes.string,
            mask: PropTypes.bool,
            maskFormat: PropTypes.string
        };
    }

    static get defaultProps() {
        return {
            format: "DD.MM.YYYY",
            tapCloseSelector: ".body-wrapper",
            mask: true,
            maskFormat: "d{.}`m{.}`Y"
        };
    }

    constructor(props) {
        super(props);

        const value = props.value || props.defaultValue;

        this.state = {
            value: value ? moment(value).format("YYYY-MM-DD") : null
        };
    }

    componentWillReceiveProps(props) {
        // update min & max date
        if ("min" in props) {
            this.picker.setMinDate(props.min ? moment(props.min).toDate() : null);
        }

        if ("max" in props) {
            this.picker.setMaxDate(props.max ? moment(props.max).toDate() : null);
        }

        if ("value" in props) {
            this.setState({value: props.value}, () => {
                this.picker.setDate(props.value ? this.normalizeDate(moment(this.state.value).toDate()) : null, true);
            });
        }
    }

    normalizeDate(d) {
        return new DateClass(DateClass.UTC(
            d.getFullYear(),
            d.getMonth(),
            d.getDate(),
            d.getHours(),
            d.getMinutes(),
            d.getSeconds()
        ));
    }

    get inputProps() {
        let props = pluckKeysExcept(
            this.props,
            Object.keys(this.constructor.propTypes).concat(["inputRef", "type", "name", "className"])
        );

        props.readOnly = !this.props.mask;
        return props;
    }

    get className() {
        let classList = [];

        if (typeof this.props.className === "string") {
            classList.push(this.props.className);
        }

        classList.push("date-picker");

        return classList.join(" ");
    }

    _setInputRef = (el) => {
        this.input = el;

        if (typeof this.props.inputRef === "function") {
            this.props.inputRef(el);
        }
    };

    _buildPicker() {
        let options = {};

        options.field = this.input;
        options.format = this.props.format;
        options.firstDay = 1;
        options.keyboardInput = false;
        options.yearRange = 100;

        options.onSelect = date => {
            this.setState({value: moment(date).format("YYYY-MM-DD")}, () => {
                if (typeof this.props.onChange === "function") {
                    this.props.onChange(date);
                }

                if (typeof this.props.handleChange === "function") {
                    this.props.handleChange(this.state.value);
                }
            });
        };

        if (this.props.min) {
            options.minDate = moment(this.props.min).toDate();
        }

        if (this.props.max) {
            options.maxDate = moment(this.props.max).toDate();
        }

        if (this.state.value) {
            options.defaultDate = this.normalizeDate(moment(this.state.value).toDate());
            options.setDefaultDate = true;
        }

        if (env.has("options.pikadayLanguage")) {
            options.i18n = env.get("options.pikadayLanguage");
        }

        const picker = new Pikaday(options);

        if (this.state.value == null) {
            picker.setDate(null);
        }

        return picker;
    }

    _buildMask() {
        return new IMask(this.input, {
            mask: DateClass,
            pattern: this.props.maskFormat
        });
    }

    _setupTapClose() {
        if (typeof this.props.tapCloseSelector !== "string") {
            return;
        }

        const element = document.querySelector(this.props.tapCloseSelector);

        if (element == null) {
            return;
        }

        hammer(element).on("tap", (e) => {

            if (!this.visible) {
                return;
            }

            if ($(e.target).parent(".date-picker") || $(e.target).parent(".pika-single")) {
                return;
            }

            this.hide();

            // Blur element
            if (typeof this.input.blur === "function") {
                if (this.props.mask) {
                    this.input.blur();
                }
            }
        });
    }

    _setupMaskHook() {
        this.input.addEventListener("input", e => {
            // Set date from value
            const date = moment(e.target.value, this.props.format, true);

            if (date.isValid()) {
                this.picker.setDate(date.toDate(), true);
            }
        });
    }

    componentDidMount() {
        this.picker = this._buildPicker();

        if (this.props.mask) {
            this.mask = this._buildMask();
            this._setupMaskHook();
        }


        this._setupTapClose();
    }

    render() {
        throw methodNotImplemented("render");
    }

    /////////////////////////////////
    // API
    /////////////////////////////////

    show() {
        this.picker.show();
        return this;
    }

    hide() {
        this.picker.hide();
        return this;
    }

    get visible() {
        return this.picker.isVisible();
    }

    get value() {
        return this.state.value;
    }
}

module.exports = Date;


// WEBPACK FOOTER //
// ./resources/js/components/abstract/Date.js